"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.absDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var absDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createAbs: _factoriesAny.createAbs
};
exports.absDependencies = absDependencies;